import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover';
import { invoke, web3Navigate } from '@web3/utils';
import clsx from 'clsx';
import { usePopoverState } from '../../../hooks';
import { Menu } from './menus';
import { isBrowser } from '../../../utils/trick';

export type MenuItemProps = {
  menu: Menu;
  scEventName?: string;
};

export function MenuItem({ menu, scEventName = 'SpotWeb3NavigationBarClick' }: MenuItemProps) {
  const currentPathname = isBrowser ? window.location.pathname : '';

  const popoverState = usePopoverState();

  const isActive = invoke(() => {
    if (menu.symbol === 'Home') {
      return false;
    }
    if (menu.link && currentPathname.startsWith(menu.link)) {
      console.log('menu.link', menu.link);
      console.log('currentPathname', menu.link);
      return true;
    }
    if (menu.children) {
      return menu.children.some((m) => m.link && currentPathname.startsWith(m.link));
    }
    return false;
  });

  if (!menu.children?.length) {
    return (
      <a
        className={clsx('web3-menu-item', isActive && 'router-link-active')}
        href={menu.link}
        data-button_name={menu.symbol}
        data-spm-even={scEventName}
        onClick={(e) => {
          e.preventDefault();
          web3Navigate(menu.link);
        }}
      >
        <span className="menu-label">{menu.title}</span>
      </a>
    );
  }
  return (
    <Popover open={popoverState.visible}>
      <PopoverTrigger asChild>
        <a
          className={clsx('web3-menu-item !outline-none', isActive && 'router-link-active')}
          href={menu.link}
          data-button_name={menu.symbol}
          data-spm-even={scEventName}
          onMouseEnter={popoverState.show}
          onMouseLeave={popoverState.hide}
          onClick={(e) => {
            web3Navigate(menu.link);
            e.preventDefault();
          }}
        >
          <span className="menu-label">{menu.title}</span>
          <i className="triangle-down">{menuArrowIcon}</i>
        </a>
      </PopoverTrigger>
      <PopoverContent align="start" asChild forceMount onOpenAutoFocus={(e) => e.preventDefault()}>
        {popoverState.domVisible && (
          <div
            className={clsx('web3-header-nav-popover')}
            style={{
              transition: 'opacity ease-in 100ms',
              opacity: popoverState.visible ? 1 : 0,
            }}
            onMouseEnter={popoverState.show}
            onMouseLeave={popoverState.hide}
            onTransitionEnd={popoverState.transitionEnd}
          >
            {menu.children.map((subMenu) => {
              return (
                <a
                  key={subMenu.symbol}
                  className={clsx('web3-submenu-item select-none', {
                    active: subMenu.symbol !== 'Home' && currentPathname.startsWith(subMenu.link),
                    'is-large': subMenu.size === 'large',
                  })}
                  target={subMenu.isBlank ? '_blank' : ''}
                  rel="noreferrer"
                  href={subMenu.link}
                  onClick={(e) => {
                    e.preventDefault();
                    web3Navigate(subMenu.link);
                  }}
                  data-button_name={menu.symbol}
                  data-spm-even={scEventName}
                  data-spm-data={JSON.stringify({
                    menu_name: subMenu.symbol,
                  })}
                >
                  <div className="flex items-center gap-[6px]">
                    <h3 className="web3-submenu-title">{subMenu.title}</h3>
                    {subMenu.isNew && (
                      <span className="new-tag">
                        <span className="new-tag-content">#New</span>
                      </span>
                    )}

                    {subMenu.hot && <div className="svg-full w-[18px] h-[18px]">{hotIcon}</div>}
                  </div>
                  {subMenu.description && <div className="web3-submenu-desc">{subMenu.description}</div>}
                </a>
              );
            })}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}

const menuArrowIcon = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="40" height="32" viewBox="0 0 40 32">
    <path d="M32.48 6.112h-26.367l13.184 19.775z"></path>
  </svg>
);

const hotIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 1410117688">
      <g id="Group 10">
        <path
          id="Vector 1"
          d="M3.63636 7.72735V11.1364H2.5V14.1667H3.63636V16.4395H4.77273V17.5758H3.63636V18.3334H11.2121H14.2424V17.5758H15.3788V15.3031H16.8939V9.24251H15.5682V8.10614H13.4848V5.83341H12.3485V3.56069H11.2121V1.66675H10.0758V5.83341H8.93939V3.1819H7.80303V4.69705H6.66667V8.86372H4.77273V7.72735H3.63636Z"
          fill="#FF5C29"
        />
        <path
          id="Vector 2"
          d="M5.53027 16.4394H6.66664V17.9545H13.4848V15.303H14.6212V14.1667H13.4848V13.0303H12.3485V10H11.2121V12.2727H10.0757V10.3788H8.93936V11.5152H7.803V13.0303H6.66664V14.5455H5.53027V16.4394Z"
          fill="#F7A600"
        />
        <path id="Vector 3" d="M11.2121 14.1667H8.9394V16.4395H7.80304V17.5758H12.3485V15.3031H11.2121V14.1667Z" fill="white" />
        <rect id="Rectangle 64" x="4.39398" y="4.69727" width="0.757576" height="0.757576" fill="#FF5C29" />
        <rect id="Rectangle 65" x="15" y="4.69727" width="0.757576" height="2.27273" fill="#FF5C29" />
        <rect id="Rectangle 66" x="8.18182" y="6.96973" width="0.757576" height="2.27273" fill="#F7A600" />
        <rect id="Rectangle 67" x="13.4849" y="9.24243" width="0.757576" height="0.757576" fill="#F7A600" />
      </g>
    </g>
  </svg>
);
